module.exports = __webpack_public_path__ + "static/img/icon @2x.3c27e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon @2x.png
// module id = QRQZ
// module chunks = 1